module.exports = __webpack_public_path__ + "img/6.981c231c.jpg";